import React from 'react';
import { ProductTypeCustomisation } from '../../common/CommonTypes';
import ProductSectionItem from './ProductSectionItem';
import './LandingPageProductSection.scss';

/**
 * `LandingPageProductSection` renders the product teaser section on the
 * customer landing page.
 *
 * It maps CMS product customisations into `ProductSectionItem` components.
 */

export type LandingPageProductSectionProps = {
  products: ProductTypeCustomisation[];
};

const LandingPageProductSection = ({
  products
}: LandingPageProductSectionProps): JSX.Element => {
  const renderProductItems = () => {
    return products.map((product: ProductTypeCustomisation, index) => (
      <ProductSectionItem
        product={product}
        index={index}
        key={`product-item-${index}`}
      />
    ));
  };

  return (
    <div className='m1-bottom'>
      <div className='flex-column product-section'>{renderProductItems()}</div>
    </div>
  );
};

export default LandingPageProductSection;
